import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tablapescador',
  templateUrl: './tablapescador.component.html',
  styleUrls: ['./tablapescador.component.css']
})
export class TablapescadorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
